export const PREVIOUS_EXACT_APPOINTMENT_CONTRACT =
  'browser-appointments.series-fence-v1' as const;
export const EXACT_APPOINTMENT_CONTRACT =
  'browser-appointments.biweekly-booking-details-v2' as const;
export const SINGLE_SESSION_APPOINTMENT_CONTRACT =
  'browser-appointments.booking-pattern-v3' as const;
export const COACH_CANCEL_APPOINTMENT_CONTRACT =
  'browser-appointments.coach-cancel-v2' as const;
export const NATIVE_COACH_RESCHEDULE_CONTRACT =
  'browser-appointments.native-coach-reschedule-v2' as const;
export const APPOINTMENT_BROWSER_CONTRACT = Symbol(
  'appointmentBrowserContract',
);

export type AppointmentBrowserContractMarker =
  | typeof EXACT_APPOINTMENT_CONTRACT
  | typeof PREVIOUS_EXACT_APPOINTMENT_CONTRACT
  | typeof SINGLE_SESSION_APPOINTMENT_CONTRACT
  | typeof COACH_CANCEL_APPOINTMENT_CONTRACT
  | typeof NATIVE_COACH_RESCHEDULE_CONTRACT;

export type LegacyAppointmentOperationContractMarker =
  | typeof EXACT_APPOINTMENT_CONTRACT
  | typeof PREVIOUS_EXACT_APPOINTMENT_CONTRACT
  | typeof SINGLE_SESSION_APPOINTMENT_CONTRACT;

export type AppointmentBrowserCapability = {
  marker: AppointmentBrowserContractMarker;
  seriesFence: true;
};

export const APPOINTMENT_BROWSER_CAPABILITY: AppointmentBrowserCapability = {
  marker: PREVIOUS_EXACT_APPOINTMENT_CONTRACT,
  seriesFence: true,
};

export const COACH_CANCEL_APPOINTMENT_CAPABILITY: AppointmentBrowserCapability =
  {
    marker: COACH_CANCEL_APPOINTMENT_CONTRACT,
    seriesFence: true,
  };
